import { skipToken } from '@reduxjs/toolkit/query';
import { useGetVehicleId } from 'pages/CreateVehicle/hooks/useGetVehicleId';
import { useGetSectionsQuery } from 'services/api/vehicle-sections';
import { Section, SectionImage } from 'services/api/vehicle-sections/types';
import { useExteriorSectionData } from './useExteriorSection';
import { useLevel1SectionData } from './useLevel1Section';

export const useExteriorGeneralSection = (): { section: Section | undefined; images: SectionImage[] } => {
  const vehicleId = useGetVehicleId();
  const { data: sections } = useGetSectionsQuery(vehicleId || skipToken);
  const { subSections, images } = useExteriorSectionData('exterior');
  const { subSections: interiorSubs } = useLevel1SectionData('interior_questions');

  const rawSection = sections?.exterior?.subsections?.exterior;
  const subsections: Record<string, Section> = {};
  if (interiorSubs.windshield?.grade) subsections.windshield = interiorSubs.windshield;
  if (subSections.exterior_paint?.grade) subsections.exterior_paint = subSections.exterior_paint;

  return {
    section: rawSection ? { ...rawSection, subsections } : undefined,
    images: images.filter((img: SectionImage) => !!img.url),
  };
};
